import { useTranslation } from "react-i18next";

import { Contact } from "../partials/contact";
import { PagePartial } from "../partials/page-partial";

export const ContactPage = () => {
  const { t } = useTranslation();
  return (
    <PagePartial title={t("page.contact")}>
      <Contact />
    </PagePartial>
  );
};
